var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"mt-5 font-weight-bold text-primary"},[_vm._v("MoreInfo page")])
}
var staticRenderFns = []

export { render, staticRenderFns }